import Enc2HEX from 'crypto-js/enc-hex';
import SHA256 from 'crypto-js/sha256';
import { Store, ModifyPasswordResStatus, ResLoginSuccess } from './type';

interface Params {
  API: {
    getSessionId: () => Promise<string>;
    modifyPassword?: ({ mobile, mobileCaptcha, password, graphicCaptcha, sessionId }: any) => Promise<ResLoginSuccess>;
    modifyPasswordPriv?: ({ password, oldPassword, sessionId, graphicCaptcha }: any) => Promise<ResLoginSuccess>;
  };
  formStore: Store<{
    oldPassword: string;
    mobile: string;
    password: string;
    mobileCaptcha: string;
    graphicCaptcha: string;
  }>;
  stateStore: Store<{
    modifyLoading: boolean;
    mobileError: string;
    passwordError: string;
    mobileCaptchaeError: string;
  }>;
}

export class ModifyPassword {
  private _API;
  public formStore;
  public stateStore;

  constructor(params: Params) {
    this._API = params.API;
    this.formStore = params.formStore;
    this.stateStore = params.stateStore;
  }

  _encryptPassword(passowrd: string) {
    return Enc2HEX.stringify(SHA256(passowrd.trim()));
  }

  fetchModifyPassword = async (): Promise<{ data?: any; status: ModifyPasswordResStatus } | undefined> => {
    this.stateStore.set({ modifyLoading: true });
    try {
      const sessionId = await this._API.getSessionId();
      const { mobile, password, mobileCaptcha } = this.formStore.value;
      if (!this._API.modifyPassword) return;
      const modifyPasswordRes = await this._API.modifyPassword({
        mobile,
        mobileCaptcha,
        password: this._encryptPassword(password),
        sessionId
      });
      console.log('fetchModifyPassword:r', modifyPasswordRes);
      return {
        status: ModifyPasswordResStatus.SUCCESS,
        data: modifyPasswordRes
      };
    } catch (e: any) {
      console.log('fetchModifyPassword:e', e.response.data);
      const errorCode = e?.response?.data?.code;
      if (errorCode === 4002002 || errorCode === 4003043) {
        this.stateStore.set({ mobileCaptchaeError: '验证码错误' });
        return { status: ModifyPasswordResStatus.CAPTCHA_ERROR };
      } else if (errorCode === 400401004) {
        this.stateStore.set({ passwordError: '设置密码失败，错误原因不能与上一次密码相同' });
        return { status: ModifyPasswordResStatus.SAME_IN_HISTORY };
      } else if (errorCode === 4001005) {
        this.stateStore.set({ mobileError: '账号未注册' });
        return { status: ModifyPasswordResStatus.MOBILE_NOT_EXISTS };
      } else if (errorCode === 4002003) {
        // 调用校验验证码频繁
        this.stateStore.set({ mobileCaptchaeError: '验证码错误次数过多，请稍后重试' });
        return { status: ModifyPasswordResStatus.CAPTCHA_BUSY };
      } else {
        this.stateStore.set({ passwordError: '未知错误' });
        return { status: ModifyPasswordResStatus.UNKONW };
      }
    } finally {
      this.stateStore.set({ modifyLoading: false });
    }
  };
}

export default ModifyPassword;
